module.exports = __webpack_public_path__ + "static/img/zhaopin.46bfcc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zhaopin.png
// module id = i/D2
// module chunks = 1